"use client";

import { ResourceContext } from "@/contexts/resource-context";
import { CookiesSetup } from "@/utility-components/cookies-setup/cookies-setup";
import { PageView } from "@/utility-components/page-view/page-view";

type PropsResourceProvider = {
  children?: ReactNode;
  value?: ResourceInfo;
};

export const ResourceProvider = ({
  children,
  value = {
    access: {
      access: true,
    },
    log: {
      polishName: "Nieznana",
      argumentsMap: {},
      category: null,
      feature: null,
      sponsored: null,
    },
  },
}: PropsResourceProvider) => {
  if (!value?.access) {
    value.access = { granted: true };
  }

  if (!value?.favouriteList) {
    value.favouriteList = false;
  }

  return (
    <ResourceContext.Provider value={value}>
      {children}

      <CookiesSetup />
      <PageView
        polishName={value?.logView?.polishName ?? "Nieznana"}
        argumentsMap={value?.logView?.argumentsMap ?? {}}
        category={value?.logView?.category}
        feature={value?.logView?.feature}
        sponsored={value?.logView?.sponsored}
      />
    </ResourceContext.Provider>
  );
};
